import {
  FormControl as MaterialFormControl,
  RadioGroup as MaterialRadioGroup,
  FormControlLabel as MaterialFormControlLabel,
} from '@material-ui/core';
import styled, { css, createGlobalStyle } from 'styled-components';

import Button from '~/components/Button';
import {
  HeaderTitle as SidesheetHeader,
  HeaderContainer as SidesheetHeaderContainer,
} from '~/components/Sidesheet/styles';
import { WEDO_DEFAULT_WIDTH } from '~/styles/breakpoints';
import colors from '~/styles/colors';
import grid from '~/styles/grid';

export const SidesheetCustomStyle = createGlobalStyle<any>`

  ${SidesheetHeaderContainer} {
    height: 4.5rem;
  }

    ${SidesheetHeader} {
      margin: 1.7rem 1.1rem 0 1.1rem;
     h3 {
       font-size: 32px;
       color: ${colors.lightblack}
     }
    }
`;

export const Container = styled.div`
  width: ${WEDO_DEFAULT_WIDTH};
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FilterTitle = styled.p`
  margin: 2.8rem 0 0 0;
  font-size: 14px;
  color: #4d4d4d;
`;

export const SubmitFilterButton = styled.button`
  width: 29.8rem;
  height: 2.8rem;
  border-radius: 5px;
  font-weight: bold;
  border: none;
  background-color: ${colors.primary};
  color: white;
  margin-top: auto;
  align-self: bottom;
  margin-bottom: 1.1rem;
`;

export const FilterContainer = styled.div``;

export const FilterWrapper = styled.div`
  display: flex;
  gap: ${grid.sm};
  align-items: center;
  justify-content: flex-end;

  width: 34.2rem;
  margin-top: -0.8rem;
  height: 3.5rem;
  float: right;

  @media (max-width: 1400px) {
    margin-top: -14px;
    width: 490px;
  }
`;

export const FilterButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.2rem;
  height: 2.8rem;
  color: white;
  border-radius: 5px;
  border: none;
  background: ${colors.primary};
`;

export const CloseButtonModal = styled.button`
  border: 0;
  background: none;
  align-self: flex-end;

  svg {
    fill: ${colors.gray};
  }
`;

export const ModalTitle = styled.h1`
  font-size: 24px;
  color: #4d4d4d;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: rgba(0, 0, 0, 0.1);
    margin: 1.1rem 0 1.8rem 0;
  }
`;

export const FormControl = styled(MaterialFormControl)`
  margin-bottom: 2.4rem !important;
`;

export const RadioGroup = styled(MaterialRadioGroup)`
  .MuiFormControlLabel-root {
    margin-right: 0.5rem;
  }

  @media (max-width: 1400px) {
    row-gap: 10px;
  }
`;

export const FormControlLabel = styled(MaterialFormControlLabel)`
  width: 10.6rem;
  height: 1.5rem;
  justify-content: center;
  border-radius: 11px;
  margin-left: 0px !important;
  padding: 0.2rem;
  font-size: 12px;
  transition: color 0.5s;
  transition: background-color 0.5s;
  transition: ease-in 0.2s;

  ${(props) =>
    props.checked &&
    css`
      background-color: ${colors.primary};
      color: #f2f6ff;
    `}

  ${(props) =>
    !props.checked &&
    css`
      color: #4d4d4d;
      background-color: transparent;
    `}

  & span:first-child {
    display: none;
  }
`;

export const CustomButton = styled(Button)`
  margin-top: 2.8rem;
`;
